import { useEffect, useState } from "react";
import FormField from "./FormField";
import "./css/book_demo.css";
import { apiUrl } from "../../../http-common";
import { emailRegex } from "../utility_functions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const BookDemo = () => {
  const [hasPickedDate, setHasPickedDate] = useState(false);
  const [
    hasSubmittedDemoRequestSuccessfully,
    setHasSubmittedDemoRequestSuccessfully,
  ] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [calendarOpen, setCalendarOpen] = useState(true);
  const [formatedSelectedDate, setFormatedSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("10:00am");
  const demo_times = ["10:00am", "11:00am", "01:00pm", "02:30pm", "04:00pm"];
  const [payload, setPayload] = useState({});
  const [isDateValid, setIsDateValid] = useState(true);
  const [isNameValid, setIsNameValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isInstitutionNameValid, setIsInstitutionNameValid] = useState(true);
  const [isRoleValid, setIsRoleValid] = useState(true);

  async function submitDemoRequest() {
    setShowLoading(true);
    const response = await fetch(`${apiUrl}demo-requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const reduced_response = await response.json();
    if (reduced_response?.data) {
      setTimeout(() => {
        setHasSubmittedDemoRequestSuccessfully(true);
        setIsLoading(false);
      }, 2000);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setHasSubmittedDemoRequestSuccessfully(false);
      }, 2000);
    }
  }

  function calculateTimeForSpecificTimeZone(offset, minusOrPlus) {
    if (offset === 0) {
      return selectedTime;
    }
    const extractedHourFromSelectedTime = parseInt(selectedTime.split(":")[0]);
    const extractedMinutesFromSelectedTime = selectedTime
      .split(":")[1]
      .slice(0, 2);

    let offsetHour;
    if (minusOrPlus === "+") {
      offsetHour = extractedHourFromSelectedTime + parseInt(offset);
    } else {
      offsetHour = extractedHourFromSelectedTime - parseInt(offset);
    }

    if (offsetHour < 0) {
      offsetHour += 24;
    }
    if (offsetHour > 12) {
      offsetHour -= 12;
    }

    const period = offsetHour >= 12 ? "pm" : "am";

    if (offsetHour === 0) {
      offsetHour = 12;
    }
    const offsetTime = `${offsetHour}:${extractedMinutesFromSelectedTime}${period}`;

    return offsetTime;
  }

  const time_zones = [
    `Abidjan, Ivory Coast (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Accra, Ghana (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Addis Ababa, Ethiopia (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Algiers, Algeria (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Asmara, Eritrea (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Bamako, Mali (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Banjul, Gambia (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Brazzaville, Republic of the Congo (${calculateTimeForSpecificTimeZone(
      1,
      "-"
    )})`,
    `Cairo, Egypt (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Casablanca, Morocco (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Ceuta, Spain (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Conakry, Guinea (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Dakar, Senegal (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Dar es Salaam, Tanzania (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Djibouti, Djibouti (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Harare, Zimbabwe (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Johannesburg, South Africa (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Kampala, Uganda (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Khartoum, Sudan (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Kigali, Rwanda (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Kinshasa, Democratic Republic of Congo (${calculateTimeForSpecificTimeZone(
      1,
      "-"
    )})`,
    `Lagos, Nigeria (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Luanda, Angola (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Lubumbashi, Democratic Republic of Congo (${calculateTimeForSpecificTimeZone(
      0,
      "+"
    )})`,
    `Malabo, Equatorial Guinea (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Maputo, Mozambique (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Maseru, Lesotho (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Mbabane, Eswatini (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Mogadishu, Somalia (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Monrovia, Liberia (${calculateTimeForSpecificTimeZone(2, "-")})`,
    `Nairobi, Kenya (${calculateTimeForSpecificTimeZone(1, "+")})`,
    `Ndjamena, Chad (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Porto-Novo, Benin (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Sao Tome, Sao Tome and Principe (${calculateTimeForSpecificTimeZone(
      2,
      "-"
    )})`,
    `Tripoli, Libya (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Tunis, Tunisia (${calculateTimeForSpecificTimeZone(1, "-")})`,
    `Windhoek, Namibia (${calculateTimeForSpecificTimeZone(0, "+")})`,
    `Adak, USA (${calculateTimeForSpecificTimeZone(12, "-")})`,
    `Anchorage, (${calculateTimeForSpecificTimeZone(11, "-")})`,
    `Anguilla, (${calculateTimeForSpecificTimeZone(6, "-")})`,
    `Antigua, (${calculateTimeForSpecificTimeZone(6, "-")})`,
    `Buenos Aires, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Catamarca, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Comodoro Rivadavia, Argentina (${calculateTimeForSpecificTimeZone(
      5,
      "-"
    )})`,
    `Cordoba, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Jujuy, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `La Rioja, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Mendoza, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Rosario, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `San Juan, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `San Luis, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Tucuman, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Ushuaia, Argentina (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Aruba, (${calculateTimeForSpecificTimeZone(6, "-")})`,
    `Asuncion, Paraguay ${calculateTimeForSpecificTimeZone(6, "-")}`,
    `Atikokan, Canada (${calculateTimeForSpecificTimeZone(7, "-")})`,
    `Atka, USA (${calculateTimeForSpecificTimeZone(12, "-")})`,
    `Bahia, Brazil (${calculateTimeForSpecificTimeZone(5, "-")})`,
    `Bahia Banderas, Mexico (${calculateTimeForSpecificTimeZone(8, "-")})`,
    `Barbados, (${calculateTimeForSpecificTimeZone(6, "-")})`,
    `Belem, Brazil (${calculateTimeForSpecificTimeZone(5, "-")})`,
  ];

  function formatLongDate(date) {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}:${month}:${day}`;
  }

  const handleDateChange = (date) => {
    const formattedDate = formatDate(date);
    const formattedLongDate = formatLongDate(date);
    setSelectedDate(formattedDate);
    setFormatedSelectedDate(formattedLongDate);

    setPayload((prev) => ({
      ...prev,
      date: formattedDate,
    }));
  };

  return (
    <div className="book_demo_container displayed_none">
      <div className="main_container">
        <button
          className="close_modal"
          onClick={() => {
            document
              .querySelector(".book_demo_container")
              .classList.toggle("displayed_none");
            setSelectedDate("");
            setFormatedSelectedDate("");
            setSelectedTime("10:00am");
            setPayload({});
          }}
        ></button>
        <div className="left">
          <div className="top">
            <div className="logo_container"></div>
            <p className="url">Brainstake.tech</p>
            <h2>School Demo</h2>
            <p className="time">2 Hour 30 min</p>
            {formatedSelectedDate && selectedTime && (
              <>
                <p className="selected_date">Date: {formatedSelectedDate}</p>
                <p className="selected_date">Time: {selectedTime}</p>
              </>
            )}
          </div>
          <div className="bottom">
            <button className="cookie_settings">Cookie settings</button>
            <button className="report_abuse">Report abuse</button>
          </div>
        </div>
        <div className="right">
          {showLoading ? (
            isLoading ? (
              <div
                className="demo_request_submission_status loading"
                style={{
                  backgroundImage: `url("/new_landing_page_images/loader.gif`,
                  backgroundSize: "150px auto",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              >
                <h3>Please wait while your demo request is being submitted</h3>
              </div>
            ) : (
              <div
                className="demo_request_submission_status is_success_or_failure"
                style={{
                  backgroundImage: `url("/new_landing_page_images/${
                    hasSubmittedDemoRequestSuccessfully
                      ? "demo_submission_success.svg"
                      : "demo_submission_failure.png"
                  }")`,
                  backgroundSize: "96px 96px",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center 30px",
                }}
              >
                <h3>
                  {hasSubmittedDemoRequestSuccessfully
                    ? "Congratulations!"
                    : "An error occurred"}
                </h3>
                <p>
                  {hasSubmittedDemoRequestSuccessfully
                    ? "Meeting has been scheduled. We have sent a confirmation to your email."
                    : "Something went wrong while submitting your demo request. Please try again"}
                </p>
                <button
                  className="back_to_home"
                  onClick={() => {
                    setShowLoading(false);
                    setIsLoading(false);
                    setHasPickedDate(false);
                    setPayload({});
                    setSelectedDate("");
                    setFormatedSelectedDate("");
                    setSelectedTime("10:00am");
                  }}
                >
                  Back to home
                </button>
              </div>
            )
          ) : !hasPickedDate ? (
            <div className="middle">
              <div className="date_picker">
                <div className="top">
                  <h3>Select a Date</h3>
                  <div className="date_component_container">
                    {/* <input
                      type="date"
                      name="selectedDate"
                      id="selectedDate"
                      placeholder="Select date"
                      className={`${!isDateValid && "failed_form_validation"}`}
                      onChange={(e) => {
                        const selecte_date = new Date(e.target.value);
                        const formattedDate = formatDate(selecte_date);
                        const formattedLongDate = formatLongDate(selecte_date);
                        setSelectedDate(formattedDate);
                        setFormatedSelectedDate(formattedLongDate);
                        setPayload((prev) => ({
                          ...prev,
                          date: formattedDate,
                        }));
                      }}
                    /> */}
                    <DatePicker
                      selected={selectedDate ? new Date(selectedDate) : null}
                      onChange={handleDateChange}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                      className={"date-input"}
                      open={calendarOpen}
                      inline
                    />
                  </div>
                  <p
                    className={`error_pick_date ${
                      !isDateValid ? "" : "displayed_none"
                    }`}
                  >
                    Please pick a date
                  </p>
                </div>
                <div className="time_zone_picker">
                  <h3>Time zone</h3>
                  <select className="time_zones">
                    {time_zones?.map((time_zone, index) => (
                      <option key={index} value={time_zone}>
                        {time_zone}
                      </option>
                    ))}
                  </select>
                  <button className="troubleshooting">Troubleshooting</button>
                </div>
              </div>
              <div className="time_picker">
                <h3>Select Time</h3>
                <p className="selected_date">
                  Date:{" "}
                  {formatedSelectedDate ? formatedSelectedDate : "Not selected"}
                </p>
                <p className="selected_date">Time: {selectedTime}</p>
                <div className="demo_times_container">
                  {demo_times?.map((demo_time, index) => (
                    <p
                      key={index}
                      className={`demo_time_container${
                        demo_time === selectedTime
                          ? " selected_time_indication_border_color"
                          : ""
                      }`}
                    >
                      <span className="selected_time_confirmation displayed_none">
                        {selectedTime} selected
                      </span>
                      <span
                        className="demo_time"
                        data_demo_time={demo_time}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.target.classList.toggle("half_size");
                          e.target.parentElement.classList.toggle("no_border");
                          e.target.parentElement
                            .querySelector(".confirm_time")
                            .classList.toggle("displayed_none");
                        }}
                      >
                        {demo_time}
                      </span>
                      <button
                        className="confirm_time displayed_none"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedTime(
                            e.target.parentElement
                              .querySelector(".demo_time")
                              .getAttribute("data_demo_time")
                          );
                          setPayload((prev) => ({
                            ...prev,
                            time: e.target.parentElement
                              .querySelector(".demo_time")
                              .getAttribute("data_demo_time"),
                          }));
                          e.target.parentElement
                            .querySelector(".demo_time")
                            .classList.toggle("half_size");
                          e.target.parentElement
                            .querySelector(".selected_time_confirmation")
                            .classList.toggle("displayed_none");
                          e.target.classList.toggle("displayed_none");
                          e.target.parentElement.classList.toggle("no_border");
                          setTimeout(() => {
                            e.target.parentElement
                              .querySelector(".selected_time_confirmation")
                              .classList.toggle("displayed_none");
                          }, 3000);
                        }}
                      >
                        Confirm
                      </button>
                    </p>
                  ))}
                  <button
                    className="next"
                    onClick={() => {
                      if (!selectedDate) {
                        setIsDateValid(false);
                        setTimeout(() => {
                          setIsDateValid(true);
                        }, 2000);
                        return;
                      }
                      setIsLoading(true);
                      setHasPickedDate(true);
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="enter_details">
              <div className="top">
                <h3>Enter your Details</h3>
                <p>
                  Have any questions or feedback? Feel free to reach out to us.
                  We are always available to help.
                </p>
                <div className="enter_details_form_fields">
                  <FormField
                    input_type="text"
                    name="full_name"
                    icon_url="/new_landing_page_images/form_avatar.svg"
                    placeholder_text="Enter your full name"
                    full_size={true}
                    setPayload={setPayload}
                    isDemo={true}
                    isValid={isNameValid}
                  />
                  <FormField
                    input_type="text"
                    name="email"
                    icon_url="/new_landing_page_images/form_envelope.svg"
                    placeholder_text="Enter email ID"
                    full_size={false}
                    setPayload={setPayload}
                    isDemo={true}
                    isValid={isEmailValid}
                  />
                  <FormField
                    input_type="phone"
                    name="phone_number"
                    icon_url="/new_landing_page_images/form_phone.svg"
                    placeholder_text="Enter Phone No"
                    full_size={false}
                    setPayload={setPayload}
                    isDemo={true}
                    isValid={isPhoneNumberValid}
                  />
                  <FormField
                    input_type="text"
                    name="institution_name"
                    icon_url="/new_landing_page_images/form_institution.svg"
                    placeholder_text="Enter Institution name"
                    full_size={true}
                    setPayload={setPayload}
                    isDemo={true}
                    isValid={isInstitutionNameValid}
                  />
                  <FormField
                    input_type="select"
                    name="role"
                    icon_url="/new_landing_page_images/form_avatar_with_gear.svg"
                    placeholder_text="Your Role"
                    full_size={true}
                    roles={[
                      "HEAD/PRINCIPAL",
                      "INSTITUTION_OWNER",
                      "DEPUTY_HEAD/PRINCIPAL",
                      "DIRECTOR",
                      "TEACHER",
                      "PARENT",
                      "STUDENT",
                      "ANCILLARY",
                    ]}
                    setPayload={setPayload}
                    isDemo={true}
                    isValid={isRoleValid}
                  />
                </div>
              </div>
              <div className="action_buttons_container">
                <button
                  className="go_back"
                  onClick={() => {
                    setIsLoading(false);
                    setHasPickedDate(false);
                  }}
                >
                  Back
                </button>
                <button
                  className="submit"
                  onClick={() => {
                    if (!payload?.full_name) {
                      setIsNameValid(false);
                      setTimeout(() => {
                        setIsNameValid(true);
                      }, 2000);
                      return;
                    }
                    if (!payload?.email) {
                      setIsEmailValid(false);
                      setTimeout(() => {
                        setIsEmailValid(true);
                      }, 2000);
                      return;
                    }
                    if (payload?.email && !emailRegex(payload?.email)) {
                      setIsEmailValid(false);
                      setTimeout(() => {
                        setIsEmailValid(true);
                      }, 2000);
                      return;
                    }
                    if (!payload?.phone_number) {
                      setIsPhoneNumberValid(false);
                      setTimeout(() => {
                        setIsPhoneNumberValid(true);
                      }, 2000);
                      return;
                    }
                    if (!payload?.institution_name) {
                      setIsInstitutionNameValid(false);
                      setTimeout(() => {
                        setIsInstitutionNameValid(true);
                      }, 2000);
                      return;
                    }
                    if (!payload?.role) {
                      setIsRoleValid(false);
                      setTimeout(() => {
                        setIsRoleValid(true);
                      }, 2000);
                      return;
                    }
                    submitDemoRequest();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookDemo;
